import { memo } from 'react';
import { Handle, Position, NodeResizer } from '@xyflow/react';

const getShape = ({ data, selected }) => {   
    return (
        <svg className='bi bi-bootstrap-fill' clip-rule="evenodd" fill-rule="evenodd"
            stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g>
                <path class="if-block" d="m11.262 2.306c.196-.196.461-.306.738-.306s.542.11.738.306c1.917 1.917 7.039 7.039 8.956 8.956.196.196.306.461.306.738s-.11.542-.306.738c-1.917 1.917-7.039 7.039-8.956 8.956-.196.196-.461.306-.738.306s-.542-.11-.738-.306c-1.917-1.917-7.039-7.039-8.956-8.956-.196-.196-.306-.461-.306-.738s.11-.542.306-.738c1.917-1.917 7.039-7.039 8.956-8.956z" fill-rule="nonzero" />
                {/* {!data.bfm_data?.name ? ( <text x="50%" y="50%" dominant-baseline="middle" font-size={5} text-anchor="middle">IF</text>) : (null)} */}
                <text x="50%" y="50%" dominant-baseline="middle" font-size={5} text-anchor="middle">IF</text>
            </g >
        </svg>
    );
}

export {
    getShape
}